export const type = {
    basic: "Basic",
    major: "Major",
    doubleMajor: "Double Major",
    minor: "Minor",
    advancedMajor: "Advanced Major",
    interdisciplinaryMajor: "Interdisciplinary Major",
    research: "Research",
    general: "General",
    basicRequired: "Basic Required",
    basicElective: "Basic Elective",
    majorRequired: "Major Required",
    majorElective: "Major Elective",
    generalRequired: "General Required",
    humanitiesSocial: "Humanities & Social Elective",
    humanities: "Humanities",
    thesisStudy: "Thesis Study",
    individualStudy: "Individual Study",
    otherElective: "Other Elective",
    unclassified: "Unclassified",
    etc: "Others",
    basicRequiredShort: "BR",
    basicElectiveShort: "BE",
    majorRequiredShort: "MR",
    majorElectiveShort: "ME",
    humanitiesSocialElectiveShort: "HSE",
    mandatoryGeneralCourseShort: "MGC",
    otherElectiveShort: "OE",
    generalRequiredShort: "GR",
    electiveGraduateShort: "EG",
    etcShort: "ETC",
    totalCredit: "Credit",
    totalAu: "AU",
}
